<template>
    <div>
        <TabelaANS
            v-model="isLoadingMedidas"
            :medidas="medidas"
            :role="role"
            @delete="itens => deleteItens(itens)"
            @delete-all="ids => deleteAll(ids)"
            @edit="index => editItem(index)"
            @view="index => viewItem(index)"
            @add="addItem()"
            @filtro-click="openFiltro()"
            @paginate="args => paginate(args)"
            @typeButton='type => this.type = type'
            ref="tabelaAns"
            class="px-6 pt-2"
        />

        <overlay-loading v-model="loadingOverlay" />

        <FiltroANS
            :value="showFiltro"
            @filtrar-medida-interventiva="filtro => filtrarMedidaInterventiva(filtro)"
            @limpar-filtro-medida-interventiva="cleanFiltro"
            @close="showFiltro = false"
        />

        <ModalANS
            ref="modalANS"
            v-model="showModal"
            :action="action"
            :onlyView="onlyView"
            :medida="medida"
            @save-changes="item => saveChanges(item)"
            @cancel="cancel"
        />

        <ExcluirModal
            :text="'Tem certeza que deseja excluir essa medida interventiva?'"
            :showDelete="showDelete"
            @close="showDelete = false"
            @confirmDelete="confirm()"
        />

        <SucessoModal
            :genericMessage="messageANS"
            :showSucess="showSucess"
            :sucessType="type"
            successName='Medida interventiva'
            @close="closeSuccess"
        />

        <ErrorModal
          v-model="error"
          :errObj="errObj"
        />
    </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import { assign } from 'lodash'

import MedidaInterventiva from '@/services/ANS/MedidaInterventiva'
import TabelaANS from './Shared/TabelaANS'
import ModalANS from './Shared/ModalANS'
import FiltroANS from './Shared/FiltroANS'
import ErrorModal from '@/components/Shared/ErrorModal/ErrorModal'
export default {
  components: {
    TabelaANS,
    ModalANS,
    FiltroANS,
    ErrorModal
  },
  data () {
    return {
      medidas: {},
      medida: {},
      showDelete: false,
      delSelect: [],
      showSucess: false,
      type: '',
      messageANS: '',
      showModal: false,
      onlyView: true,
      action: 'view',
      showFiltro: false,
      isLoadingMedidas: true,
      role: '',
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      showModalAnexo: false,
      // Error Handler
      error: false,
      errObj: {},
      loadingOverlay: false,
      args: ''
    }
  },
  async beforeMount () {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role
  },
  methods: {
    async cleanFiltro () {
      this.isLoadingMedidas = true
      this.$refs.tabelaAns.tipoIntervencaoId = -1
      this.$refs.tabelaAns.filtro = 'VIGENTE'
      this.getAllMedidaInterventiva(this.args)
    },
    async paginate (args) {
      this.isLoadingMedidas = true
      this.args = args
      this.getAllMedidaInterventiva(args)
    },
    async closeSuccess () {
      this.showSucess = false
      this.isLoadingMedidas = true
      await this.getAllMedidaInterventiva(this.args)
      this.isLoadingMedidas = false
    },
    async getAllMedidaInterventiva (args) {
      let medidaInterventiva = new MedidaInterventiva(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        let responseMedidaInterventiva = await medidaInterventiva.getMedidaInterventiva(args)
        this.medidas = responseMedidaInterventiva.data
        this.medidas.conteudo.map((el) => {
          el.observacao = el.observacao ? el.observacao : ''
        })
        this.isLoadingMedidas = false
      } catch (err) {
        this.isLoadingMedidas = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    async putMedidaInterventiva (medidaInterventiva) {
      let medidaInterventivaPut = new MedidaInterventiva(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        await medidaInterventivaPut.putMedidaInterventiva(medidaInterventiva)
        this.messageANS = 'Medida interventiva adicionada com sucesso!'
        this.showModal = false
        this.showSucess = true
      } catch (err) {
        this.isLoadingMedidas = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    async deleteMedidaInterventiva (delSelct) {
      let medidaInterventivaDelete = new MedidaInterventiva(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        medidaInterventivaDelete.deleteMedidaInterventiva(delSelct)
        await this.getAllMedidaInterventiva(this.args)
        this.messageANS = 'Medida interventiva excluída com sucesso!'
        this.showSucess = true
      } catch (err) {
        this.isLoadingMedidas = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    deleteItens (itens) {
      this.delSelect = []
      this.showDelete = true
      itens.forEach(item => {
        this.delSelect.push(this.medidas.conteudo[item].id)
      })
    },
    deleteAll (ids) {
      this.delSelect = []
      this.showDelete = true
      ids.forEach(id => {
        this.delSelect.push(id)
      })
    },
    async confirm () {
      this.isLoadingMedidas = true
      this.showDelete = false
      await this.deleteMedidaInterventiva(this.delSelect)
      this.isLoadingMedidas = false
    },
    success () {
      this.showSucess = true
    },
    editItem (index) {
      this.action = 'edit'
      this.onlyView = false
      this.showModal = true
      this.getMedidaInterventiva(index)
      this.$refs.modalANS.medidaSelecionadaDOU()
    },
    viewItem (index) {
      this.$refs.modalANS.$forceUpdate()
      this.action = 'view'
      this.onlyView = true
      this.showModal = true
      this.getMedidaInterventiva(index)
    },
    getMedidaInterventiva (index) {
      assign(this.medida, this.medidas.conteudo[index])
    },
    addItem () {
      let newMedida = {
        id: null,
        tipoIntervencao: {
          id: null,
          nome: '',
          ativo: false,
          ordem: null
        },
        resolucaoOperacional: null,
        dataPublicacao: '',
        diasValidade: null,
        observacoes: '',
        status: false
      }
      this.medida = newMedida
      this.action = 'add'
      this.onlyView = false
      this.showModal = true
    },
    async saveChanges (item) {
      this.showModal = false
      this.loadingOverlay = true
      await this.putMedidaInterventiva(item)
      this.loadingOverlay = false
    },
    cancel () {
      this.showModal = false
    },
    openFiltro () {
      this.showFiltro = true
    },
    filtrarMedidaInterventiva (filtro) {
      this.showFiltro = false
      this.isLoadingMedidas = true
      this.$refs.tabelaAns.filtro = filtro.vigencia
      this.$refs.tabelaAns.tipoIntervencaoId = (filtro.tipoIntervencao !== null) ? filtro.tipoIntervencao.id : ''
      this.args = this.$refs.tabelaAns.args
      this.getAllMedidaInterventiva(this.args)
    }
  }
}
</script>

<style scoped>

</style>
